import { i18n } from "@/services/i18n-setup";

export const email = value => (!value || !!value?.match(/^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/)) || i18n.t('feedback.invalidEmail');